import { cn } from "@babybjorn/ui";

import type { FC, InputHTMLAttributes } from "react";
import * as s from "./PillInput.module.scss";

type PillInputProps = InputHTMLAttributes<HTMLInputElement> & {
	id: string;
	name: string;
	label: string;
	className?: string;
};

const PillInput: FC<PillInputProps> = ({
	id,
	name,
	label,
	className,
	...rest
}) => (
	<>
		<input
			type="radio"
			id={id}
			name={name}
			className={cn(s.pillInput, className)}
			{...rest}
		/>
		<label htmlFor={id} className={s.pillLabel}>
			{label}
		</label>
	</>
);
export default PillInput;
